'use client'
import { alpha } from '@mui/system/colorManipulator';
import { common } from '@mui/material/colors';
import { error, info, neutral, success, warning } from '../colors';
import { getPrimary } from '../utils';
import { createBrandColor, readableOn } from "@theme/shared/create-brand-color";

export const createPalette = (config) => {
  const { colorPreset, contrast, branding } = config;

  // Tenant branding: `adminPrimary` → palette.primary, `adminSecondary` →
  // palette.secondary + the legacy `brand2` accent string. Dark-mode defaults.
  const adminPrimary = createBrandColor(branding?.adminPrimary);
  const adminSecondary =
    createBrandColor(branding?.adminSecondary) ?? createBrandColor(neutral[800]);
  // Feature-bar (side-nav) text colours — item text and the active item text.
  const navText = createBrandColor(branding?.adminNavText)?.main ?? neutral[400];
  const navActiveText =
    createBrandColor(branding?.adminNavActiveText)?.main ?? common.white;

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[100], 0.38),
      disabledBackground: alpha(neutral[100], 0.12),
      focus: alpha(neutral[100], 0.16),
      hover: alpha(neutral[100], 0.04),
      selected: alpha(neutral[100], 0.12),
    },
    background: {
      default: contrast === 'high' ? '#0B0F19' : '#0E1320',
      paper: neutral[900],
    },
    brand: "#E17000",
    brand2: adminSecondary.main,
    // Text/icon variants of brand/brand2 — lightened until readable on the
    // dark paper (unchanged when the colour already reads fine).
    brandText: readableOn("#E17000", neutral[900]),
    brand2Text: readableOn(adminSecondary.main, neutral[900]),
    divider: '#2D3748',
    error,
    info,
    mode: 'dark',
    neutral,
    primary: adminPrimary ?? getPrimary(colorPreset),
    secondary: adminSecondary,
    navText,
    navActiveText,
    success,
    text: {
      primary: '#EDF2F7',
      secondary: '#A0AEC0',
      disabled: 'rgba(255, 255, 255, 0.48)',
    },
    warning,
  };
};
